var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96",
    id: "success",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 38.5,
    stroke: "#12182B",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#12182B",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M30 49C31.6423 50.6423 35.4196 54.4196 39.6712 58.6712C41.2333 60.2333 43.7663 60.2337 45.3284 58.6716L67 37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.70861f979fdf953c26c087a4fadea97f.svg";
export { ForwardRef as ReactComponent };